module.exports = __webpack_public_path__ + "img/login-select.59263ea2.jpg";